"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var removeAccents_1 = require("../removeAccents");
/**
 * Utilitná funkcia pre odstránenie diakritiky z textu (použitie funkcie removeAccents) a nahradenie ďalších znakov pre kompatibilitu s URL
 * @param {string} - Text pre konverziu
 * @returns {string}
 * @example
 * ```javascript
 * import slugify from 'utilities/lib/slugify';
 *
 * const text = 'Utilitné funkcie Sportnet Online';
 * console.log(slugify(text)); // utilitne_funkcie_sportnet_online
 * ```
 */


function slugify(text) {
  if (!text) {
    return '';
  }

  return removeAccents_1.removeAccents(text).toLowerCase().replace(/\s+/g, '_').replace(/^-+/, '').replace(/-+$/, '');
}

exports.default = slugify;